import { add, sub } from 'date-fns'

export const validStartDate = sub(new Date(Date.now()), { years: 100 })
export const validEndDate = add(new Date(Date.now()), { years: 100 })
